import { CommonModule } from '@angular/common';
import { Component, Injector, Input, OnInit } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { RouterModule } from '@angular/router';
import { TemplateGaurdDirective } from 'src/app/shared/directives/template-gaurd.directive';
import { SideMenuItem } from 'src/app/shared/interfaces';
import { SideNavItemComponent } from '../side-nav-item/side-nav-item.component';
import { TranslateModule } from '@ngx-translate/core';
import { NavBarService } from 'src/app/shared/services/nav-bar.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { BaseComponent } from 'src/app/shared/component/base-component/base.component';
import { takeUntil } from 'rxjs';

@Component({
  selector: 'app-side-nav',
  standalone: true,
  imports: [
    CommonModule,
    MatSidenavModule,
    MatListModule,
    RouterModule,
    MatIconModule,
    TemplateGaurdDirective,
    TranslateModule,
    MatExpansionModule,
    SideNavItemComponent,
  ],
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss'],
})
export class SideNavComponent extends BaseComponent implements OnInit {
  menuList: SideMenuItem[];
  @Input() isSmallScreen: boolean;
  @Input() isSideNavCollapsed: boolean;
  @Input() isEmptySideBar: boolean;

  constructor(injector: Injector, private navBarService: NavBarService) {
    super([], injector);
  }

  ngOnInit(): void {
    this.initalizeSideMenuItems();
  }

  onClickSideMenuItem(isActive: boolean): void {
    if(isActive && this.isSmallScreen) {
      this.navBarService.closeSideNavBar();
    }
  }

  // privates
  private initalizeSideMenuItems(): void {
   this.menuList = this.isEmptySideBar ? [] : this.navBarService.getSideNavItems();
  }
}
